import { ForgotPasswordSuccessForm } from '@psyomics/ui-components';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordSuccess = () => {
  const navigate = useNavigate();

  return <ForgotPasswordSuccessForm onReturnToLogin={() => navigate('/')} />;
};

export { ForgotPasswordSuccess };
